/**
 * PAPPO — messagePreview
 * Texto curto de uma mensagem (para citação, banner de resposta, encaminhar e
 * pré-visualização de conversa). Anexos sem texto viram um rótulo com ícone.
 */
export function messagePreview(m: {
  message_type?: string | null;
  content?: string | null;
}): string {
  const t = m.message_type;
  if (t === 'image') return m.content || '📷 Foto';
  if (t === 'sticker') return '😀 Figurinha';
  if (t === 'audio') return m.content || '🎤 Áudio';
  if (t === 'video') return m.content || '🎬 Vídeo';
  return m.content || '';
}
